export default __webpack_public_path__ + "static/media/e3.713e0af2.jpg";